/*
 * Copyright 2024 Mifos Initiative
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 *
 * See https://github.com/openMF/mobile-wallet/blob/master/LICENSE.md
 */
package org.mifospay.feature.mpay.qr.scan

import kotlinx.browser.window

actual object WebPlatform {
    actual val isWeb: Boolean = true

    actual val isWebDesktop: Boolean by lazy {
        !isMobileBrowser()
    }

    private fun isMobileBrowser(): Boolean {
        val userAgent = window.navigator.userAgent.lowercase()

        // Check for mobile keywords in user agent
        val mobileKeywords = listOf(
            "android",
            "webos",
            "iphone",
            "ipad",
            "ipod",
            "blackberry",
            "windows phone",
            "mobile",
        )

        val isMobileUserAgent = mobileKeywords.any { userAgent.contains(it) }

        // Also check for touch capability and screen size as secondary indicators
        val hasTouch = js("('ontouchstart' in window || navigator.maxTouchPoints > 0)") as Boolean
        val isSmallScreen = window.innerWidth <= 768

        return isMobileUserAgent || (hasTouch && isSmallScreen)
    }
}
